import { UserLevel } from '@app/core/models/user-level';
import { UserLevelMapping } from '@app/menu/utils/user-level-mapping';
import { CurrentRouteData } from '@app/routing/models/current-route-data';

/**
 * @returns `UserLevel` based on current URL (active route)
 */
export function findUserLevel(currentRouteData: CurrentRouteData): UserLevel {
  const mapping = UserLevelMapping.find((level) => level.isActive(currentRouteData.url));
  return mapping.userLevel;
}
